import { Box } from "@chakra-ui/react";
import { baseColors, BaseStack } from "goi_common/src/design-system";
import { ReactNode } from "react";
import { SangjoGraphicIcon } from "./sangjoLandingData";

/** DS 그래픽 아이콘. 다색 원본이라 ColorIcon 대신 img 로 그린다. */
export const GraphicIcon = ({ name, size }: { name: SangjoGraphicIcon; size: number }) => (
  <Box
    as="img"
    src={`/sangjo-landing/${name}.svg`}
    alt=""
    width={`${size}px`}
    height={`${size}px`}
    flexShrink={0}
  />
);

/** 섹션 틀. 상단 8px 구분선(accent-1) + 좌우 20 패딩. */
export const LandingSection = ({
  children,
  paddingBottom = 48,
  bg = baseColors.background_normal,
}: {
  children: ReactNode;
  paddingBottom?: number;
  bg?: string;
}) => (
  <BaseStack
    width="100%"
    bg={bg}
    borderTop={`8px solid ${baseColors.background_accent_1}`}
    p={`48px 20px ${paddingBottom}px`}
  >
    {children}
  </BaseStack>
);

export const Eyebrow = ({
  children,
  color = baseColors.label_assistive_1,
}: {
  children: ReactNode;
  color?: string;
}) => (
  <Box className="body_2_normal_m" color={color}>
    {children}
  </Box>
);

export const SectionTitle = ({ children }: { children: ReactNode }) => (
  <Box className="title_3_b" color={baseColors.label_normal}>
    {children}
  </Box>
);

export const Accent = ({ children }: { children: ReactNode }) => (
  <Box as="span" color={baseColors.primary_orange}>
    {children}
  </Box>
);
